import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';
import { ModalComponent } from './modal.interface';
import { DialogButtonComponent } from '../buttons/dialog-button.component';
import { GiftcardPreviewComponent } from '../giftcard/giftcard-preview.component';
import { CircleButtonComponent } from '../buttons/circle-button.component';
import { Subject, firstValueFrom } from 'rxjs';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    DialogButtonComponent,
    GiftcardPreviewComponent,
    CircleButtonComponent
  ],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-lg w-full">
      <div class="relative p-6">
        <!-- Close button in the top right -->
        <div class="absolute top-4 right-4 z-10">
          <app-circle-button
            icon="fa-times"
            size="10"
            type="solid"
            fontSize="lg"
            (onClick)="close()"
          ></app-circle-button>
        </div>

        <h2 class="text-xl font-bold mb-4 pr-10">Förhandsgranskning</h2>
        <div class="py-4">
          <app-giftcard-preview
            [templateId]="data.templateId"
            [senderName]="data.senderName"
            [receiverName]="data.receiverName"
            [message]="data.message"
            [amount]="data.amount"
          ></app-giftcard-preview>
        </div>
      </div>
    </div>
  `
})
export class GiftcardPreviewDialogComponent implements ModalComponent {
  modalData?: any;

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: {
      templateId: string;
      senderName: string;
      receiverName: string;
      message: string;
      amount: number;
    }
  ) {
    this.modalData = data;
  }

  close() {
    this.modalService.close();
  }

  /**
   * Static helper method to open the giftcard preview dialog
   */
  static showGiftcardPreview(
    modalService: ModalService,
    templateId: string,
    senderName: string,
    receiverName: string,
    message: string,
    amount: number
  ): Promise<void> {
    const subject = new Subject<void>();

    modalService.show(GiftcardPreviewDialogComponent, {
      data: {
        templateId,
        senderName,
        receiverName,
        message,
        amount
      }
    });

    return firstValueFrom(subject);
  }
}
